import BookData from '../data/bookData.json'
import { useParams } from "react-router";
import BookQuote from "../Components/BookQuote";
import Blurb from "../Components/Blurb";
import React, { useEffect, useRef, useState } from "react";
import Fade from 'react-reveal/Fade';
import EndButtons from '../Components/DetailButtons';
import ElevateAppBar from '../Components/Header';
import RasterAd from '../Components/RasterAd';
import BookSegment from '../Components/BookSegment';
import { Link } from 'react-router-dom';
import SimilarBooks from '../Components/SimilarBooks';

const BookDetails = () => {

    const { key } = useParams();
    
    
    

    useEffect(() => 
    window.scrollTo({top: 0, behavior: 'smooth'}),
    );

    function copy() {
        const el = document.createElement('input');
        el.value = window.location.href;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }

  

    return ( 
        <div >
        <ElevateAppBar></ElevateAppBar>
        

        <br></br><br></br><br></br>

        <div className= 'image-area'>
         <Fade>
             <div className= 'circle'>
                 <div className = 'image-container'>
                     <img src = {BookData[ key ].cover}></img>
                 </div>
             </div>
         </Fade>
        </div>
            <div className= 'book-title'>
               <h2 className = 'title'>  {BookData[ key ].title }</h2>
               <br/>
               <h2 className= 'author'>  {BookData[ key ].author }</h2>
            </div>

                <br/><br/>


                <div className= 'quote-container'>


                    <BookQuote quote= {BookData[ key ]["quote-1"] }/>
                    <BookQuote quote= {BookData[ key ]["quote-2"] }/>
                    <BookQuote quote= {BookData[ key ]["quote-3"] }/>
                
                
                    
                    <Blurb blurb = {BookData[key].blurb}></Blurb>
                </div>

            <div className = 'bottom-container'>
            <EndButtons imageLink={BookData[key].cover} amazonLink={BookData[key].amazon}></EndButtons>

            
{/* 
            {BookData.map((book, randomNumber) => 


            <Fade >
            <Link to = { book.randomNumber }>
                <div className= 'book'>
                <div className = 'single-book' key = {randomNumber}>

                        <img src = {book.cover} alt = '' loading='lazy'></img>
                </div> 
                </div>
            </Link>
            </Fade>


            )} */}

            
            
              
                
            </div>   <div className='detailAd'><RasterAd></RasterAd></div>  


            <div className='genre-title-bookdetails'><h2>More Interesting Books</h2></div>
            <div className='book-container'><SimilarBooks></SimilarBooks></div>

            <div className='detailAd'> <RasterAd></RasterAd></div>

            <div className= 'end-note'>
                <h3>Not finding the book you want  <br></br>( ˘︹˘ )<Link to= '/contact'><font style= {{color: 'var(--accent)'}}>Contact us!</font></Link></h3>
            </div>


            
        </div>
     );
}
 
export default BookDetails;